<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Customer
            <v-icon right>add_circle</v-icon>
          </v-btn>
          <v-btn color="primary" @click="openDialog = true"
            >Import Customer</v-btn
          >
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm2>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                v-model="queryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-select
                :items="creditLevelList"
                v-model="queryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-select
                :items="customerTypes"
                v-model="queryParams.customerType"
                label="Choose Customer Type"
                item-text="label"
                item-value="value"
              >
              </v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12>
        <v-card>
          <v-card-text class="font-weight-bold">
            <div>
              <v-btn
                :loading="printAllButtonLoading"
                color="primary"
                @click="printAllCustomer('printCustomer')"
                >PRINT ALL</v-btn
              >
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                @click="exportAllCustomer()"
                >EXPORT ALL</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="customerList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phoneNo }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.creditLevel.name }}</td>
              <td>{{ props.item.customerType }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <customerExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></customerExcel>
    <!-- print section -->
    <div
      id="printCustomer"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Customers</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Customer Code</th>
              <th style="text-align: left">Customer Name</th>
              <th style="text-align: left">Email</th>
              <th style="text-align: left">Phone No</th>
              <th style="text-align: left">Address</th>
              <th style="text-align: left">Credit Level</th>
              <th style="text-align: left">Customer Type</th>
              <th style="text-align: left">Updated Date</th>
              <th style="text-align: left">Updated By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allCustomerList" :key="index">
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phoneNo }}</td>
              <td>{{ item.address }}</td>
              <td>{{ item.creditLevel.name }}</td>
              <td>{{ item.customerType }}</td>
              <td>
                {{
                  item.updatedDateInMilliSeconds | format-ms-date-time
                }}
              </td>
              <td>{{ item.updatedBy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { commonService } from "../../services/common-service";
import customerExcel from "../customer/CustomerExcel";

export default {
  name: "CustomerList",

  components: { customerExcel },
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Customer",
        disabled: true,
      },
    ],
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Address", value: "address" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Customer Type", value: "customerType" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", value: "name", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    customerList: [],
    allCustomerList: [],
    openDialog: false,
    printAllButtonLoading: false,
    totalRows: 0,
    queryParams: {
      code: "",
      name: "",
      email: "",
      creditLevelId: "",
      customerType: "",
    },
    creditLevelList: [],
    customerTypes: [{ label: "---All---", value: "" }],
  }),
  watch: {
    pagination: {
      handler() {
        this.getCustomerList();
        this.getAllCustomers();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.email) {
      this.queryParams.email = this.$route.query.email;
    }
    if (this.$route.query.creditLevelId) {
      this.queryParams.creditLevelId = this.$route.query.creditLevelId;
    }
    if (this.$route.query.customerType) {
      this.queryParams.customerType = this.$route.query.customerType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCreditLevels();
    this.getAllCustomerTypes();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "customers", query: this.queryParams });
      this.getCustomerList();
      this.getAllCustomers();
    },
    getCustomerList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      customerService
        .getCustomers(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getAllCustomers() {
      this.printAllButtonLoading = true;
      customerService
        .getAllCustomer(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allCustomerList = res.data.customerList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getCustomerList();
      this.getAllCustomers();
    },
    onRegister() {
      this.$router.push("/customer/new");
    },
    onEdit(customer) {
      // go to details page
      this.$router.push("/customer/" + customer.id);
    },
    exportAllCustomer() {
      this.printAllButtonLoading = true;
      customerService
        .exportCustomerExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    printAllCustomer(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var reprintWindow = window.open("", "MsgWindow", "width=500,height=500");
      reprintWindow.document.write(printContents);
      setTimeout(() => {
        reprintWindow.print();
        reprintWindow.close();
      }, 600);
    },
    getAllCustomerTypes() {
      customerService
        .getAllCustomerTypes()
        .then((res) => {
          let tempList = res.data;
          for (let temp of tempList) {
            let tempObj = {
              label: temp,
              value: temp,
            };

            this.customerTypes.push(tempObj);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>